import { render, staticRenderFns } from "./ClassroomPageLayout.vue?vue&type=template&id=1343a59c&"
import script from "./ClassroomPageLayout.vue?vue&type=script&lang=js&"
export * from "./ClassroomPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomPageLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports